// ThemeContext.js
import { createContext, useState, useMemo, useEffect } from 'react';
import { ThemeProvider, CssBaseline, createTheme } from '@mui/material';
import { lightTheme, darkTheme } from '../../theme';
import { apiFetch } from '../../utils/auth';
export const ColorModeContext = createContext({
  toggleColorMode: () => {},
  mode: 'light',
});


export const CustomThemeProvider = ({ mode, setMode, children }) => {
  useEffect(() => {
    if (mode === 'dark') {
      document.body.setAttribute('data-theme', mode);
    } else {
      document.body.removeAttribute('data-theme');
    }
  }, [mode]);

  const toggleColorMode = async () => {
    const newMode = mode === 'light' ? 'dark' : 'light';
    setMode(newMode);
    try {
      await apiFetch('login/savetheme', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ Mode: newMode }),
      });
    } catch (error) {
      console.error('Failed to save theme:', error);
      // Revert on error
      setMode(mode);
    }
  };

  const theme = useMemo(() => (mode === 'light' ? lightTheme : darkTheme), [mode]);

  return (
    <ColorModeContext.Provider value={{ toggleColorMode, mode }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};
